import React, {Fragment, useEffect, useState} from "react";

import Component from "./components/Component";
import { BringzzIcon, BringzzText, BringzzButton } from "@bringzz/components";

import { getUserLanguages } from "./helpers/user";
import useRequest from "hooks/useRequest";

export default function CmsPage({
    ...props
}) {
    const [pageData, setPageData] = useState(null);
    const { sendRequest, data, error, loading } = useRequest();
    
    const setMetaData = (page) => {
        if (page.metaKeywords){
            let metaKeywords = ('meta[name="keywords"]');
            if(metaKeywords.length)
                metaKeywords.attr('content', page.metaKeywords);
            else 
                (`<meta name="keywords" content="${page.metaKeywords}"/>`).insertAfter('title');
        }

        if (page.metaDescription){
            let metaDescription = ('meta[name="description"]');
            if(metaDescription.length) 
                metaDescription.attr('content', page.metaDescription);
            else 
            (`<meta name="description" content="${page.metaDescription}"/>`).insertAfter('title');
        }

        if (page.metaTitle){
            let metaTitle = ('meta[name="title"]');
            if(metaTitle.length) 
                metaTitle.attr('content', page.metaTitle);
            else 
            (`<meta name="title" content="${page.metaTitle}"/>`).insertAfter('title');
        }

        if(page.noIndex == 1)
            ('<meta name="robots" content="noindex, nofollow"/>').insertAfter('title');
        
    }
    useEffect(() => {
        if(!pageData){
            sendRequest({
                method: 'POST',
                url: `/module/getPageInFrontend/cmspage`,
                data: {lang: getUserLanguages(), slug: window.location.pathname ?? '/'}
            }).then(data => {
                    if (data.data && data.status === 'success') {
                        if(data.message == 'doccheck') {
                            return window.location.href = data.data.redirect;
                        }
                        let page = data.data;
                        document.title = `${page.title ?? document.title}`; 
                        setPageData(page);
                        setMetaData(page);
                        
                    } else {
                        setPageData(false);
                    }
                });
        }
    }, [])

    return (
        <Fragment>
            {
                pageData &&
                <div className='frontend-text cms-page' style={{ backgroundColor: pageData.backgroundColor }}>
                    {
                        pageData.components.map(component =>
                        <Component
                            key={component.uuid}
                            component={component}
                            hideHeader={pageData.hideHeader == 1}
                            hideFooter={pageData.hideFooter == 1}
                            {...props} />
                    )}
                </div>
            }
            {
                loading &&
                <div className="bg-magic-lilac min-h-screen w-full flex items-center justify-center">
                    <BringzzIcon
                        size="32"
                        icon="IconSpinner"
                        folder="LineIcons"
                        className="animate-spin text-white"
                    />
                </div>
            }
            {
                pageData === false &&
                <div className="bg-magic-lilac min-h-screen w-full flex flex-col">
                    <div className="flex-1 flex items-center justify-center">
                        <div className="text-center">
                            <BringzzText tag="h1" className="text-white text-4xl md:text-6xl font-bold mb-8">
                                404 -Not found
                            </BringzzText>
                            <div className="flex justify-center">
                                <BringzzButton 
                                    size="lg"
                                    className="text-white bg-midnight-blue"
                                    onClick={() => window.location.href = '/'}
                                >
                                    Go Home
                                </BringzzButton>
                            </div>
                        </div>
                    </div>
                    <div className="m-2 px-4 pt-8 rounded-xl">
                        <div className="text-center py-4">
                            <BringzzText tag="h1">Bringzz</BringzzText>
                            <BringzzText tag="h4" className="font-normal">
                                since 2023 ©
                            </BringzzText>
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    )
}